<template>
  <tabbed title="Detalle de la transacción">
    <PaymentInvoice
      v-for="info in tables"
      :key="info.folio"
      :info="info"
    />
  </tabbed>
</template>

<script>
import Tabbed from '@/components/Tabbed';
import PaymentInvoice from './PaymentInvoice';

export default {
  name: 'PaymentDetail',
  components: { Tabbed, PaymentInvoice },
  props: { paymentInfo: { type: Object, required: true }, money: { type: String, required: true } },
  data() {
    const { usaFlow } = this.paymentInfo.successInfo;
    return {
      tables: this.paymentInfo.successInfo.invoicesInfo.map(
        ({ formattedClientId, total, folio }) => ({
          folio,
          phone: formattedClientId,
          amount: this.formatMoney(total, this.money, 2, usaFlow),
          authCode: this.paymentInfo.successInfo.authCode,
          operationDate: this.paymentInfo.successInfo.operationDate
        })
      )
    };
  },
  methods: {
    formatMoney(amount, currency, decimals, usaFlow) {
      return `${usaFlow ? '$' : currency} ${(amount + 0).toFixed(decimals)} ${usaFlow ? 'USD' : ''}`;
    }
  }
};
</script>
